import React from "react"
import PropTypes from "prop-types"
import cn from "classnames"

import styles from "./nav.module.css"

export const Nav = ({ children, ...props }) => {
  // filtering out style and className
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  return (
    <nav>
      <ul
        role="menubar"
        aria-labelledby="appbar-hamburger"
        className={cn(styles.List)}
        {...rest}
      >
        {children}
      </ul>
    </nav>
  )
}

Nav.displayName = "Nav"

Nav.propTypes = {
  /**
   * React nodes to render in the Nav content.
   */
  children: PropTypes.node.isRequired,
}
